import './init'
import Form from './ui/form'
import DatabaseManagement from './ui/db-management'
import Queries from './ui/queries'
import ExtensionService from 'live/services/extension'
import i18n from 'live/services/i18n'

const mongodb = {
    name: 'MongoDB',
    type: 'mongodb',
    origin: 'Plugin MongoDB',
    roles: ['storage', 'query'],
    icon: '/content/plugin-mongodb/mongodb.png',
    ui: {
        form: Form,
        view: null,
        custom: {
            'db-management': {
                label: i18n('Collections'),
                component: DatabaseManagement
            },
            queries: {
                label: i18n('Queries'),
                component: Queries
            }
        }
    }
}

ExtensionService.register(mongodb)
